// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

const lastWarning = new Map<string, number>();
const WARNING_INTERVAL_MS = 60_000;

/** Static operation labels only: never pass errors, URLs, tokens or user data. */
export function logWarning(operation: string): void {
  const now = Date.now();
  const previous = lastWarning.get(operation);
  if (previous !== undefined && now - previous < WARNING_INTERVAL_MS) return;
  lastWarning.set(operation, now);
  console.warn('[optional-operation-unavailable]', operation);
}

/** allSettled absorbs rejection; callers must still expose unavailable references. */
export function logRejectedSettlements(
  results: readonly PromiseSettledResult<unknown>[],
  operation: string,
): void {
  if (results.some((result) => result.status === 'rejected')) logWarning(operation);
}
